import { PortfoliosVersionsService_portfolioVersionsServiceV3GetLatest } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosVersionsService_portfolioVersionsServiceV3GetLatest'

export const useLazyFetchPortfolioLatest =
  PortfoliosVersionsService_portfolioVersionsServiceV3GetLatest.useLazyQuery
